import InfoIcon from '@mui/icons-material/Info';
import { Avatar, Box, Grid, IconButton, Stack, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ShepherdTourContext } from 'react-shepherd';
import {
  WsColors,
  formatDateInMonthAndYear,
  IUserDTO,
  WsTitleColors,
  WsTitleHeader,
} from 'wisestep-base';

import { useUserContext } from '../../../../../context';
import ErrorLogger from '../../../../../providers/ErrorLogger';
import { AppLayoutTheme } from '../../../../candidates/utils/CandidateHelper';

const JobListHeader = () => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const tour = useContext(ShepherdTourContext);
  const dateSince = formatDateInMonthAndYear(loggedInUser?.registeredOn ?? '') ?? 'not mentioned';

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
      <AppLayoutTheme>
        <Box p={4}>
          <Stack direction="row">
            <Grid item xs={6}>
              <WsTitleHeader
                color={WsTitleColors.WHITE}
                title={
                  loggedInUser?.displayName ?? loggedInUser?.fullName ?? 'Name is not Available'
                }
                subtitle={`Member since ${dateSince} `}
                startIcon={<Avatar src="/images/Ahmed.png" alt=" " />}
                reversed={false}
              />
            </Grid>
            <Grid item xs={6} container justifyContent="flex-end">
              {/* <WsTitleHeader subtitle="Postings" title="128" color={WsTitleColors.PRIMARY200} />
  <WsTitleHeader subtitle="Submissions" title="67" color={WsTitleColors.PRIMARY200} />
  <WsTitleHeader subtitle="Mappings" title="45" color={WsTitleColors.PRIMARY200} />
  <WsTitleHeader subtitle="Tasks" title="32" color={WsTitleColors.PRIMARY200} /> */}
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ float: 'right' }}>
                <Tooltip title=" Tour Guide">
                  <IconButton onClick={() => tour?.start()}>
                    <InfoIcon style={{ color: WsColors.White, fontSize: 37 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
          </Stack>
        </Box>
      </AppLayoutTheme>
    </ErrorBoundary>
  );
};

export default JobListHeader;
